/**
 * Brands on a slot placement in booking order: "1. Flos · 2. Hay ·
 * Serax (added by hand)". Who signed up first on the booking page gets the
 * first tile (product grid: left to right, top to bottom). Hover a name for
 * its sign-up time.
 */
import { BookingOrderEntry } from '../../lib/types';

const when = (iso: string) =>
  new Date(iso).toLocaleString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' });

export default function BookingOrder({ order, fallback = '—' }: { order: BookingOrderEntry[]; fallback?: string }) {
  if (!order.length) return <span style={{ color: 'var(--ink-5)' }}>{fallback}</span>;
  let n = 0;
  return (
    <span>
      {order.map((o, i) => (
        <span key={o.brand_id}>
          {i > 0 && ' · '}
          {o.signed_up_at ? (
            <span title={`Signed up ${when(o.signed_up_at)}`}>
              <b style={{ fontWeight: 650 }}>{++n}.</b> {o.name}
            </span>
          ) : (
            <span title="Tagged by hand — not booked on the booking page, so no place in the order">
              {o.name} <span style={{ color: 'var(--ink-4)' }}>(added by hand)</span>
            </span>
          )}
        </span>
      ))}
    </span>
  );
}
